import { memo, useCallback } from "react";
import { useFormikContext } from "formik";
import { dictionary } from "../../lib/dictionary";

function CommonFilterBoxes({ name, data = [], label, className = "" }) {
    const { setFieldValue, values } = useFormikContext();
    const selected = values[name] || [];

    const handleSelect = useCallback(
        (value) => {
            const next = selected.includes(value)
                ? selected.filter((item) => item !== value)
                : [...selected, value];
            setFieldValue(name, next);
        },
        [selected, setFieldValue, name]
    );

    return (
        <div className="flex flex-wrap mb-3 md:mb-4 pb-2">
            <div className="w-full md:w-1/6 mt-1 mb-2 md:mb-1">
                <span className="para-label-box">{label}</span>
            </div>
            <div className="w-full md:w-5/6">
                <div className="box-container">
                    {data.map((item) => {
                        const isSelected = selected.includes(item);
                        // Always render tooltip - prefer dictionary expansion,
                        // fall back to the item itself. Some filter groups
                        // (symmetry, lab) already use full names where the
                        // dictionary lookup returns the same string.
                        const tooltip = dictionary(item) || String(item);
                        return (
                            <label key={item} className="shape-box-wrapper">
                                <input
                                    type="checkbox"
                                    value={item}
                                    checked={isSelected}
                                    onChange={() => handleSelect(item)}
                                    className="shape-checkbox"
                                />
                                <span
                                    className={`commonFilterBox ${className} ${
                                        isSelected ? "selected" : ""
                                    }`}
                                    data-tooltip={tooltip}
                                    title={tooltip}
                                >
                                    {item}
                                </span>
                            </label>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default memo(CommonFilterBoxes);
